import { Tournaments } from '@/routes/Tournaments';

/** Community — your community tournaments (pins the `community` view). See EventsPanel. */
export function CommunityPanel() {
  return (
    <div className="-mx-4 h-full">
      <Tournaments forcedView="community" />
    </div>
  );
}
